(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
/**
 * AffiliateWP Multi-Tier Commissions admin
 *
 * @since 1.0.0
 */

'use strict';

/* eslint-disable no-console, no-undef */
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
affiliatewp.attach('mtc',
/**
 * MTC Component.
 *
 * @since 1.0.0
 */
{
  /**
   * Populated dynamically via wp_add_inline_script().
   */
  data: {},
  /**
   * Adds select2 functionality to the Parent Affiliate field.
   *
   * @since 1.0.0
   */
  initParentAffiliateDropdown: function initParentAffiliateDropdown() {
    var perPage = 10;
    jQuery('#parent-affiliate-id').off().select2({
      width: '350px',
      allowClear: false,
      ajax: {
        url: affiliatewp.mtc.data.ajaxUrl,
        dataType: 'json',
        delay: 250,
        data: function data(params) {
          var _affiliatewp$mtc$data;
          return {
            action: 'affiliatewp_mtc_parent_affiliate_select',
            nonce: affiliatewp.mtc.data.nonce,
            q: params.term,
            page: params.page || 1,
            per_page: perPage,
            affiliate_id: (_affiliatewp$mtc$data = affiliatewp.mtc.data.affiliateID) !== null && _affiliatewp$mtc$data !== void 0 ? _affiliatewp$mtc$data : 0
          };
        },
        processResults: function processResults(data, params) {
          params.page = params.page || 1;
          return {
            results: data.items,
            pagination: {
              more: params.page * perPage < data.total
            }
          };
        },
        cache: true
      },
      placeholder: affiliatewp.mtc.data.i18n.select2placeholder,
      minimumInputLength: -1
    });

    // Open the select2 dropdown when clicking on the Parent Affiliate label.
    jQuery('.form-row[data-field="parent-affiliate"] label').on('click', function () {
      jQuery(this).closest('tr').find('select').select2('open');
    });
  },
  /**
   * Toggle the remove button visibility.
   *
   * The remove button should be visible only if we have 3 or more tiers on the screen,
   * since this is a multi tier system, we always need more than one tier configured.
   *
   * @since 1.0.0
   */
  toggleRemoveButtonVisibility: function toggleRemoveButtonVisibility() {
    var $removeTier = jQuery('.affwp-remove-tier');

    // Determine if the remove tier button should be shown or hidden.
    if (jQuery('.affwp-tier-row').length >= 3) {
      $removeTier.css('display', 'block');
      return;
    }
    $removeTier.css('display', 'none');
  },
  initSelect2: function initSelect2($elements) {
    $elements.each(function () {
      var $select = jQuery(this);
      $select.select2(affiliatewp.parseArgs(
      /*
       * You can use an object with select2 arguments in your select tag to override
       * the select2 defaults or add new setting.
       */
      $select.data('select2-settings') || {}, {
        width: '170px',
        minimumResultsForSearch: -1
      }));
    });
  },
  /**
   * Initiate the tiers repeater in the Settings screen.
   *
   * @since 1.0.0
   */
  initTiersRepeater: function initTiersRepeater() {
    // The table body jQuery object.
    var $root = jQuery('#affwp-tier-rows');

    // Add new button jQuery object.
    var $addNewButton = jQuery('#affwp-new-tier');

    // Tracks the total number of rows added so far.
    var total = $root.find('.affwp-tier-row').length;
    var getRowTemplate = function getRowTemplate(fields) {
      // Copy the row HTML template.
      var row = affiliatewp.mtc.data.tiersRowHtml;

      // Replace all the {{var}} found in the HTML template.
      Object.entries(fields).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        row = row.replace(new RegExp("{{\\b".concat(key, "\\b}}"), 'g'), value);
      });
      return row;
    };
    $addNewButton.on('click', function (e) {
      e.preventDefault();
      var $row = jQuery(getRowTemplate({
        index: total,
        rate: '',
        flat_type_options: ''
      }));
      $root.append($row);

      // Update total of rows.
      total = $root.find('.affwp-tier-row').length;
      affiliatewp.mtc.toggleRemoveButtonVisibility();
      affiliatewp.mtc.initSelect2($row.find('select'));

      // Focus on the input field in the new row.
      $root.find('.affwp-tier-row').find('input').focus();

      // Cap the number of tiers.
      if (total >= affiliatewp.mtc.data.maxReferralTiers) {
        $addNewButton.attr('disabled', true);
        $addNewButton.attr('aria-disabled', true);
      }
    });

    // Remove row.
    jQuery(document).on('click', '.affwp-remove-tier', function (e) {
      e.preventDefault();

      // Ensure the button is always active.
      $addNewButton.attr('disabled', false);
      $addNewButton.attr('aria-disabled', false);

      // Remove the row.
      jQuery(this).parent().remove();
      affiliatewp.mtc.toggleRemoveButtonVisibility();
    });
    affiliatewp.mtc.toggleRemoveButtonVisibility();
  }
});

},{}]},{},[1]);
